import { TextField } from "@fluentui/react";

import { Product } from "../../../slice/newFormReducers";
import { useColumnOnChangeFn, useColumnSelector } from "./hooks";

type Props = {
  uuid: string;
  shipmentEditMode?: boolean;
};

const key: keyof Product = "description";

export default ({ uuid, shipmentEditMode }: Props) => {
  const value = useColumnSelector(uuid, key);
  const onChange = useColumnOnChangeFn(uuid, key);

  return (
    <TextField
      maxLength={256}
      value={value || ""}
      disabled={shipmentEditMode}
      onChange={onChange}
      multiline={value ? value.length > 30 : false}
      autoAdjustHeight
    />
  );
};
